import { Menu, Icon } from 'antd';
import './ReportSidebar.less';
import React, { useMemo, useState } from 'react';
import { CategoriesData, ScoreData, SectionData } from './types';
import { filterObjectByKeys, getCumulatedSectionsScoreData } from './utils';

const { SubMenu } = Menu;

type Props = {
    scoreData: ScoreData;
    categories: CategoriesData;
    sections: Record<string, SectionData>;
};

export default function ReportSidebar({ scoreData, categories, sections }: Props) {
    const [openKeys, setOpenKeys] = useState<string[]>(['general']);

    const handleOpenChange = (newOpenKeys: string[]) => {
        setOpenKeys(newOpenKeys.filter((openKey) => !openKeys.includes(openKey)));
    };

    const categoryEntries = useMemo(() => Object.entries(categories), [categories]);

    return (
        <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
            className="report-sidebar custom-scrollbar"
        >
            <Menu.Item
                key="1"
                data-cy="general"
                className="single-item"
            >
                <a
                    href="#header-seo-summary"
                    className="submenu-container"
                >
                    <span className="submenu-title">
                        <Icon type="check-circle" />
                        <span>General</span>
                    </span>
                    <div className="submenu-result-data">
                        <div className="submenu-result failed">
                            {scoreData.failed} <span className="result-data-indicator" />
                        </div>

                        <div className="submenu-result warning">
                            {scoreData.warning} <span className="result-data-indicator" />
                        </div>

                        <div className="submenu-result passed">
                            {scoreData.passed} <span className="result-data-indicator" />
                        </div>
                    </div>
                </a>
            </Menu.Item>

            {categoryEntries.map(([categoryName, categorySections]) => {
                const sectionsInCategory = filterObjectByKeys(sections, categorySections);
                const categoryScoreData = getCumulatedSectionsScoreData(sectionsInCategory);

                const sectionEntries = Object.entries(sectionsInCategory);
                return (
                    <Menu.ItemGroup key={categoryName}>
                        <Menu.Divider />
                        <SubMenu
                            data-cy={categoryName}
                            key={categoryName}
                            className="submenu-item"
                            title={
                                <div className="submenu-container">
                                    <span className="submenu-title">
                                        <Icon type="check-circle" />
                                        <span>{categoryName}</span>
                                    </span>
                                    <div className="submenu-result-data">
                                        <div className="submenu-result failed">
                                            {categoryScoreData.failed} <span className="result-data-indicator" />
                                        </div>

                                        <div className="submenu-result warning">
                                            {categoryScoreData.warning} <span className="result-data-indicator" />
                                        </div>

                                        <div className="submenu-result passed">
                                            {categoryScoreData.passed} <span className="result-data-indicator" />
                                        </div>
                                    </div>
                                </div>
                            }
                        >
                            {sectionEntries.map(([sectionKey, section]) => {
                                return section && section.title ? (
                                    <Menu.Item
                                        key={sectionKey}
                                        data-cy={categoryName}
                                        className={section.result.status}
                                    >
                                        <a href={`#${sectionKey}`}>
                                            <span className="result-data-indicator" />
                                            {section.title}
                                        </a>
                                    </Menu.Item>
                                ) : null;
                            })}
                        </SubMenu>
                    </Menu.ItemGroup>
                );
            })}
        </Menu>
    );
}
